"use client";

import type React from "react";
import { useEffect, useState } from "react";
import CountUp from "react-countup";
import { motion } from "framer-motion";
interface Counter {
  id: string;
  number: number;
  symbol: string;
  title: string;
}
interface CounterSectionProps {
  counters: Counter[];
}
const CounterSection: React.FC<CounterSectionProps> = ({
  counters
}) => {
  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById("counter-section");
      if (section) {
        const rect = section.getBoundingClientRect();
        if (rect.top <= window.innerHeight * 0.75 && !isScrolled) {
          setIsScrolled(true);
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isScrolled]);
  return <section id="counter-section" className="relative" data-sentry-component="CounterSection" data-sentry-source-file="counter-section.tsx">
      <div className="relative container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {counters.map((counter, index) => <motion.div key={counter.id} initial={{
          opacity: 0,
          y: 20
        }} animate={isScrolled ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="p-8 text-center rounded-xl bg-neutral-200 dark:bg-neutral-800 bg-opacity-90 dark:bg-opacity-80 backdrop-blur-md shadow-xl border border-white border-opacity-20 dark:border-neutral-700">
              <h3 className="text-4xl font-bold text-neutral-900 dark:text-neutral-100 mb-2">
                {isScrolled && <CountUp end={counter.number} duration={2.5} separator="," useEasing={true} />}
                <span className="ml-1">{counter.symbol}</span>
              </h3>
              <p className="text-lg text-neutral-900 dark:text-neutral-100 mt-4 font-medium">{counter.title}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};
export default CounterSection;